// extracted by mini-css-extract-plugin
module.exports = {"picker":"Langs_picker__1o65f","appear":"Langs_appear__2EIvs","flag":"Langs_flag__1NzwA"};